"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.border = void 0;
exports.border = {
    width: {
        thick: "2px",
        thin: "1px",
    },
    radius: {
        sm: "2px",
        md: "4px",
    },
};
//# sourceMappingURL=index.js.map